import Vue from 'vue'
Number.prototype.toFixed = function(d) {
  let s = this + ''
  if (!d) d = 0
  if (!s.includes('.')) s += '.'
  s += new Array(d + 1).join('0')
  if (new RegExp('^(-|\\+)?(\\d+(\\.\\d{0,' + (d + 1) + '})?)\\d*$').test(s)) {
    let s = '0' + RegExp.$2
    const pm = RegExp.$1
    let a = RegExp.$3.length
    let b = true
    if (a === d + 2) {
      a = s.match(/\d/g)
      if (parseInt(a[a.length - 1]) > 4) {
        for (let i = a.length - 2; i >= 0; i--) {
          a[i] = parseInt(a[i]) + 1
          if (a[i] === 10) {
            a[i] = 0
            b = i !== 1
          } else break
        }
      }
      s = a.join('').replace(new RegExp('(\\d+)(\\d{' + d + '})\\d$'), '$1.$2')
    }
    if (b) s = s.substr(1)
    return (pm + s).replace(/\.$/, '')
  }
  return this + ''
}

// 限制输入带两位小数点金额指令
Vue.directive('price', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(input.value)) {
        input.value = ''
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})



// WEBPACK FOOTER //
// ./src/utils/mixins.js